import { QueryClient, onlineManager } from '@tanstack/react-query';

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => onlineManager.setOnline(true));
  window.addEventListener('offline', () => onlineManager.setOnline(false));
  onlineManager.setOnline(navigator.onLine);
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, networkMode: 'online' },
    // Queue mutations while offline; replay on reconnect.
    mutations: { retry: 0, networkMode: 'offlineFirst' },
  },
});
